// Mikael was here
import * as React from 'react';
import 'app.css';
import App from 'app/App';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import * as ReactDOM from 'react-dom';

const rootEl = document.querySelector('#root');
ReactDOM.render(<App />, rootEl);
